// extracted by mini-css-extract-plugin
export default {"image":"ProfilePhotoCircle_image__ZGIsg","squared":"ProfilePhotoCircle_squared__3+w5V"};